import { FaInstagram, FaFacebook, FaEnvelope } from "react-icons/fa";
import { ImWhatsapp } from "react-icons/im";
import { IoCall } from "react-icons/io5";
import "./Footer.css";
import AadviLogo from "../assets/Aadvi-logo-f.png";
import { Link } from "react-router-dom";

const socialLinks = [
  {
    name: "Instagram",
    link: "https://www.instagram.com/aadvi_designer_studio/",
    icon: <FaInstagram />,
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/profile.php?id=61551895273719",
    icon: <FaFacebook />,
  },
  {
    name: "Whatsapp",
    link: "https://wa.me/+918807427126",
    icon: <ImWhatsapp />,
  },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <div className="brand-logo">
              <img src={AadviLogo} alt="Logo" className="logo" />
              <span className="brand-name">Label Aadvi</span>
            </div>
            <p>Creating timeless fashion with elegance and style.</p>
            <div className="social-icons">
              {socialLinks.map(({ name, link, icon }) => (
                <a key={name} href={link} target="_blank" rel="noreferrer">
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Policies Section */}
          <div className="footer-policies">
            <h4>Policies</h4>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms & Conditions</Link>
            <Link to="/shipping-policy">Shipping Policy</Link>
            <Link to="/cancellation-refunds">Cancellation & Refunds</Link>
          </div>

          {/* Contact Section */}
          <div className="footer-contact">
            <h4>Contact Us</h4>
            <div className="contact-info">
              <span><FaEnvelope /> labelaadvi@gmail.com</span>
              <span><IoCall /> +91 8807427126</span>
            </div>
            <img 
              src="https://aaradesigner.com/storage/2024/07/payments.png" 
              alt="Payments" 
              className="payment-img"
            />
          </div>
        </div>

        {/* Copyright */}
        <div className="copyright">
          <p>© {currentYear} <strong> <span className="text-primary"> FlareMinds Technology and Services</span></strong>. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;